import React from 'react'
import Text from '../../components/text/Text'
import WizButton from '../../components/button/WizButton'
import {blockTypeDefinitions, STYLE_GUIDE_ITEMS} from './constants'
import {styleTokenToClassName} from './utils'

interface IProps {
    open: boolean
    onClose: () => void
    blockTypes: string[] // live /kinds 계약의 block_types
}

const BlockTypeGuideModal: React.FC<IProps> = ({open, onClose, blockTypes}) => {
    if (!open) return null
    const definitions = blockTypeDefinitions(blockTypes)
    return (
        <div className={'fixed inset-0 z-modal flex items-center justify-center'}>
            <div className={'absolute inset-0 bg-black/50'} onClick={onClose} />
            <div className={'relative z-10 w-[90%] max-w-[560px] bg-white rounded-[8px] p-[24px] shadow-hover'}>
                <Text className={'text-h3 text-font01'}>블록 타입 목록</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    content_blocks의 각 블록 type과 JSON에 넣을 수 있는 속성입니다.
                </Text>

                <div className={'mt-[16px] border border-line02 rounded-[8px] overflow-hidden max-h-[60vh] overflow-y-auto'}>
                    <div className={'grid grid-cols-[200px_1fr] bg-line02 px-[16px] py-[10px]'}>
                        <Text className={'text-ti3 font-bold text-font01'}>type</Text>
                        <Text className={'text-ti3 font-bold text-font01'}>설명</Text>
                    </div>
                    {definitions.map(block => (
                        <div key={block.type} className={'grid grid-cols-[200px_1fr] px-[16px] py-[10px] border-t border-line02'}>
                            <Text className={'text-body2 font-bold text-sub_blue'}>{block.type}</Text>
                            <Text className={'text-body2 text-font02'}>{block.description}</Text>
                        </div>
                    ))}
                </div>

                <Text className={'text-h3 text-font01 mt-[24px]'}>스타일 목록</Text>
                <Text className={'text-ti3 text-font03 mt-[6px]'}>
                    style에 넣을 수 있는 값과 적용 결과 미리보기입니다.
                </Text>

                <div className={'mt-[16px] border border-line02 rounded-[8px] overflow-hidden max-h-[40vh] overflow-y-auto'}>
                    <div className={'grid grid-cols-[140px_1fr_140px] bg-line02 px-[16px] py-[10px]'}>
                        <Text className={'text-ti3 font-bold text-font01'}>style</Text>
                        <Text className={'text-ti3 font-bold text-font01'}>설명</Text>
                        <Text className={'text-ti3 font-bold text-font01'}>미리보기</Text>
                    </div>
                    {STYLE_GUIDE_ITEMS.map(style => (
                        <div key={style.token} className={'grid grid-cols-[140px_1fr_140px] items-center px-[16px] py-[10px] border-t border-line02'}>
                            <Text className={'text-body2 font-bold text-sub_blue'}>{style.token}</Text>
                            <Text className={'text-body2 text-font02'}>{style.description}</Text>
                            <span className={`text-body2 text-font01 ${styleTokenToClassName(style.token)}`}>{style.label}</span>
                        </div>
                    ))}
                </div>

                <div className={'mt-[24px] flex justify-end'}>
                    <WizButton text={'닫기'} onClick={onClose} />
                </div>
            </div>
        </div>
    )
}

export default BlockTypeGuideModal
